export default __webpack_public_path__ + "static/media/icon-delete.a8735772.svg";